module.exports = __webpack_public_path__ + "static/Grupo 61-1d9df8bf40ec965fb712c2576ef81d0b.svg";